import React, { useMemo } from 'react';
import { Field, FastField } from 'formik';
import AsyncSelectField from 'customField/AsyncSelectField';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {any} props.label
 * @param {string} props.placeholder
 * @param {string} props.classNameContainer - Class name of div that wrapping label, input and error message
 * @param {string} props.classNameLabel
 * @param {{ label: any, value: string | number }} props.defaultOptions
 * @param {boolean} props.isFastField
 * @param {boolean} props.v2
 * @param {boolean} props.isMulti
 * @param {boolean} props.isClearable
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isLoading
 * @param {boolean} props.required
 * @param {Object} props.style
 * @param {boolean} props.closeMenuOnSelect
 * @param {(event) => void} props.afterOnChange - if v2 enabled -> params will be value that selected: (valueSelected) => void
 * @param {(inputValue: string, callback: function, page: number, onSuccess: function) => void} props.loadOptions
 * @returns
 */
const Select = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;

  const defaultArray = useMemo(() => [], []);

  return (
    <FieldWrapper
      component={AsyncSelectField}
      paging
      cacheOptions
      defaultOptions={defaultArray}
      {...props}
    />
  );
};

export default Select;
